import {
  defineComponent,
  getCurrentInstance,
  reactive,
  watch
} from '@vue/composition-api'
import './index.scss'
import _ from 'lodash'
import { useSelector } from '@/utils/bhooks'
import i18n from '@/locales'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import BarScore from '@/pages/Survey/components/BarScore'
import StarScore from '@/pages/Survey/components/StarScore'
import FaceScore from "@/pages/Survey/components/FaceScore";
import CommonTetxEdit from '@/components/CommonTetxEdit'

const ScaleEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isDraft: {
      type: Boolean
    }
  },
  setup(props, context) {
    const { surveyDetail } = useSelector(({ surveyDetail }) => ({
      surveyDetail
    }))
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      isDraft: _.cloneDeep(props.isDraft)
    })
    const instance = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return instance?.proxy.$t(initParam) as string
    }
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )
    watch(
      () => props.isDraft,
      (val) => {
        state.isDraft = val
      }
    )

    const isAllowEdit = () => {
      let res: boolean
      res = surveyDetail.surveyConfigNoDraftState?.surveyContent?.topics?.some(
        (item) => {
          return item.id == state.editItem.id
        }
      )
      return res
    }

    const updateValue = (value) => {
      state.editItem.value = value
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }

    return () => {
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.lbquestionName')}:
            </div>
            <RichUtil
              onchangeValue={(value) => (state.editItem.topicName = value)}
              placeholder={tran('survy.plctopicname')}
              value={state.editItem.topicName}></RichUtil> */}
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder= {tran('survy.lbquestionName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.lbremark')}:
            </div>
            <RichUtil
              onchangeValue={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }
              placeholder={tran('survy.plcremark')}
              value={state.editItem.topicSetting.topicRemark}></RichUtil> */}
            {/* <el-input
              type="textarea"
              class='rich-input'
              autosize={true}
              resize="none"
              size='small'
              placeholder="请输入题目备注"
              value={state.editItem.topicSetting.topicRemark}
              onInput={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>
          <div class="topic-edit-content-item">
            {!state.editItem.topicSetting.scoreStyle && (
              <BarScore
                minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                maxScore={state.editItem.topicSetting.maxScore}
                onupdateValue={(value) => updateValue(value)}
                value={state.editItem.value}
                topicSetting={state.editItem.topicSetting}></BarScore>
            )}
            {state.editItem.topicSetting.scoreStyle === 1 && (
              <StarScore
                minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                maxScore={state.editItem.topicSetting.maxScore}
                onupdateValue={(value) => updateValue(value)}
                value={Number(state.editItem.value) || state.editItem.value}
                topicSetting={state.editItem.topicSetting}></StarScore>
            )}
            {state.editItem.topicSetting.scoreStyle === 2 && (
              <FaceScore
                minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                maxScore={state.editItem.topicSetting.maxScore}
                onupdateValue={(value) => updateValue(value)}
                value={Number(state.editItem.value) || state.editItem.value}
                topicSetting={state.editItem.topicSetting}></FaceScore>
            )}
          </div>
         
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.lbelend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              id={state.editItem.id}
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              maxScore={state.editItem.topicSetting.maxScore}
              minScoreDesc={state.editItem.topicSetting.minScoreDesc}
              maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
              scoreStyle={state.editItem.topicSetting.scoreStyle}
              isAllowEdit={isAllowEdit()}
              customizeOption={
                state.editItem.topicSetting.customizeOption ? true : false
              }
              customizeOptionValue={
                state.editItem.topicSetting.customizeOptionValue
              }
              onChangeMaxScore={(value) => {
                state.editItem.topicSetting.maxScore = value
              }}
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeMinScoreDesc={(value) => {
                state.editItem.topicSetting.minScoreDesc = value
              }}
              onChangeMaxScoreDesc={(value) => {
                state.editItem.topicSetting.maxScoreDesc = value
              }}
              onChangeScoreStyle={(value) => {
                state.editItem.topicSetting.scoreStyle = value
              }}
              onChangeCustomizeOption={(value) => {
                state.editItem.topicSetting.customizeOption = value
              }}
              onChangeCustomizeOptionValue={(value) => {
                state.editItem.topicSetting.customizeOptionValue = value
              }}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default ScaleEdit
